import React from "react";
import { ActionCardButtons } from "../ui/popups/ActionCardButtons";
import { motion } from "framer-motion";
export const ActionsRequiredSection: React.FC<any> = ({
  actionsRequiredItems,
  actionButtons,
  className = "",
}) => {
  if (!actionsRequiredItems || actionsRequiredItems.length === 0) {
    return (
      <div className={`text-center text-gray-500 py-8 ${className}`}>
        No actions required at this time.
      </div>
    );
  }

  return (
    <motion.div
      className="connection-cards-section px-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <div className="connection-cards-container gap-2 flex flex-col m-2 md:flex-row md:gap-4 md:items-center md:justify-center">
        {actionsRequiredItems.map((item: any, index: number) => (
            <div className="mb-6 -mt-6 last:mb-2" key={item.id}>
            <ActionCardButtons
              className="bg-white shadow-lg rounded-3xl p-4"
              key={item.id}
              item={item}
              buttons={
              item.type === "incoming_follower_request"
                ? [{ ...actionButtons[0], text: "Approve" }, ...actionButtons.slice(1)]
                : actionButtons
              }
            />
            </div>
        ))}
      </div>
    </motion.div>
  );
};
